import { ApplicationElement, html } from '@beunity/lit-components';
import translations from './translations.js';
import style from './style.lit.css';
import '@beunity/lit-components/components/icon_block/element.js';

/**
 * Card pre-header
 *
 * @prop href - Link to card full view
 * @prop type - Card type short name (options: news, date, engagement, event, marketplace, organize, poll)
 */
export default class CardPreheader extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];
  /** @internal */
  static translations = translations;

  static properties = {
    href: { type: String },
    type: { type: String },
  };

  /** @internal */
  get typeName() {
    return this.t(`type.${this.type}`);
  }

  /** @internal */
  get icon() {
    return {
      news: 'newspaper',
      date: 'calendar-alt',
      engagement: 'human-greeting',
      event: 'calendar-day',
      marketplace: 'shopping-basket',
      organize: 'clipboard-list',
      poll: 'chart-pie',
    }[this.type];
  }

  render() {
    return html`
      <a href=${this.href}>
        <ef-icon-block text=${this.typeName} icon=${this.icon}></ef-icon-block>
      </a>
    `;
  }
}

CardPreheader.registerTagName('bu-card-preheader');

customElements.get('bu-card-preheader') ||
  customElements.define('bu-card-preheader', CardPreheader);
